import { render, staticRenderFns } from "./EBillingPortalList.vue?vue&type=template&id=188f8536&"
import script from "./EBillingPortalList.vue?vue&type=script&lang=js&"
export * from "./EBillingPortalList.vue?vue&type=script&lang=js&"
import style0 from "./EBillingPortalList.vue?vue&type=style&index=0&id=188f8536&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports